import type { Step } from '../../../../types';
import { Step1, Step2, Step3, Step4 } from '../steps';

export const steps = [
  {
    name: 'Step 1: Apply for a loan',
    title: 'Apply for a loan',
    component: Step1,
  },
  {
    name: 'Step 2: About the applicant',
    title: 'About the applicant',
    component: Step2,
  },
  {
    name: 'Step 3: About the household',
    title: 'About the household',
    component: Step3,
  },
  {
    name: 'Step 4: About unsecured debt',
    title: 'About unsecured debt',
    component: Step4,
  },
] satisfies Step[];
